import { useState } from "react";

import { useHistory } from "react-router-dom";
import { SwipeableDrawer } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import "./mobileMenu.scss";

import {
  BriefCaseMobile,
  Close,
  MenuIcon,
  TargetMobile,
  UserMobile,
  UsersMobile,
} from "../../../uiKit/assets/svg/icons";
import { blue010, blue600, gray900 } from "../../../uiKit/assets/colors/colors";
import Title from "../../../uiKit/Title/Title";

import PersonalSettings from "../PersonalSettings/personalSettings";
import GeneralMenu from "../CommunityMenu/generalMenu";
import Header from "../../Header/header";

const MENU = [
  { title: "Campaigns", url: "/campaigns", Icon: TargetMobile },
  { title: "Communities", url: "/communities/all", Icon: UsersMobile },
  { title: "Jobs", url: "/jobs", Icon: BriefCaseMobile },
  { title: "Personal settings", url: "/settings", Icon: UserMobile },
];

const useStyles = makeStyles(() => ({
  paper: {
    width: "100%",
    backgroundColor: blue010,
  },
}));

export const MobileMenuFooter = () => {
  const history = useHistory();

  const navigateHandler = (url) => {
    history.push(url);
  };

  return (
    <div className="mobileMenuFooterWrapper">
      {MENU.map(({ url, Icon }) => (
        <div className="items" onClick={() => navigateHandler(url)}>
          <Icon color={history.location.pathname.includes(url.split("/")[1]) ? blue600 : gray900} />
        </div>
      ))}
    </div>
  );
};

export const MobilePersonalSettingsMenu = () => (
  <div className="personalSettings">
    <Header title="Personal Settings" />
    <PersonalSettings />
  </div>
);

const MobileMenu = () => {
  const drawerClasses = useStyles();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mobileMenu">
      <div onClick={() => setIsOpen(true)}>
        <MenuIcon />
      </div>
      <SwipeableDrawer
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onOpen={() => setIsOpen(true)}
        classes={drawerClasses}
      >
        <div className="sidebarMobile">
          <div className="mobileMenuHeader">
            <div className="mobileMenuTitle">Settings</div>
            <div onClick={() => setIsOpen(false)}>
              <Close />
            </div>
          </div>
          <div className="communityMenu">
            <div className="communityWrapper">
              <div className="contentWrapper">
                <GeneralMenu onClose={() => setIsOpen(false)} />
              </div>
            </div>
          </div>
          <div className="personalSettings">
            <Title
              text="Personal Settings"
              lineHeight={32}
              fontSize={20}
              style={{
                padding: "8px 24px",
              }}
            />
            <PersonalSettings />
          </div>
        </div>
      </SwipeableDrawer>
    </div>
  );
};

export default MobileMenu;
